<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Preloader -->
        <PagePreloader v-if="invoiceIsLoading"></PagePreloader>

        <!-- NOTE - Switch displayer -->

        <template v-if="currentPage == 'profile'">
            <!-- Content -->
            <div class="row">
                <!--begin::Aside-->
                <div class="col-xl-3 gutter-b">
                    <!--begin::Profile Card-->
                    <div class="card card-custom">
                        <div class="card-header py-3">
                            <div class="card-title align-items-start flex-column">
                                <h3 class="card-label font-weight-bolder text-dark">
                                    Your Profile
                                </h3>
                                <span class="text-muted font-weight-bold font-size-sm mt-1"
                                    >View your profile &amp; settings</span
                                >
                            </div>
                        </div>
                        <!--begin::Body-->
                        <div class="card-body pt-4">
                            <!--begin::Nav-->
                            <div
                                class="navi navi-bold navi-hover navi-active navi-link-rounded py-2"
                            >
                                <!-- NOTE - Personal -->
                                <div class="navi-item mb-2">
                                    <a
                                        @click="setPanel('personal')"
                                        class="navi-link py-4"
                                        :class="currentPanel == 'personal' ? 'active' : ''"
                                    >
                                        <span class="navi-icon mr-2">
                                            <span class="svg-icon">
                                                <inline-svg
                                                    src="/media/svg/icons/General/User.svg"
                                                ></inline-svg>
                                            </span>
                                        </span>
                                        <span class="navi-text font-size-lg">
                                            Personal Information
                                        </span>
                                    </a>
                                </div>
                                <!-- NOTE - Change password -->
                                <div class="navi-item mb-2">
                                    <a
                                        @click="setPanel('password')"
                                        class="navi-link py-4"
                                        :class="currentPanel == 'password' ? 'active' : ''"
                                    >
                                        <span class="navi-icon mr-2">
                                            <span class="svg-icon">
                                                <inline-svg
                                                    src="/media/svg/icons/Communication/Shield-user.svg"
                                                ></inline-svg>
                                            </span>
                                        </span>
                                        <span class="navi-text font-size-lg">
                                            Change Password
                                        </span>
                                    </a>
                                </div>
                                <!-- NOTE - Change email -->
                                <div class="navi-item mb-2">
                                    <a
                                        @click="setPanel('email')"
                                        class="navi-link py-4"
                                        :class="currentPanel == 'email' ? 'active' : ''"
                                    >
                                        <span class="navi-icon mr-2">
                                            <span class="svg-icon">
                                                <inline-svg
                                                    src="/media/svg/icons/Communication/Mail-opened.svg"
                                                ></inline-svg>
                                            </span>
                                        </span>
                                        <span class="navi-text font-size-lg"> Email settings </span>
                                    </a>
                                </div>
                                <!-- NOTE - Change address -->
                                <div class="navi-item mb-2">
                                    <a
                                        @click="setPanel('address')"
                                        class="navi-link py-4"
                                        :class="currentPanel == 'address' ? 'active' : ''"
                                    >
                                        <span class="navi-icon mr-2">
                                            <span class="svg-icon">
                                                <inline-svg
                                                    src="/media/svg/icons/Communication/Adress-book2.svg"
                                                ></inline-svg>
                                            </span>
                                        </span>
                                        <span class="navi-text"> Billing Address </span>
                                    </a>
                                </div>
                                <!-- NOTE - View invoices -->
                                <div class="navi-item mb-2">
                                    <a
                                        @click="setPanel('invoices')"
                                        class="navi-link py-4"
                                        :class="currentPanel == 'invoices' ? 'active' : ''"
                                    >
                                        <span class="navi-icon mr-2">
                                            <span class="svg-icon">
                                                <inline-svg
                                                    src="/media/svg/icons/Text/Article.svg"
                                                ></inline-svg>
                                            </span>
                                        </span>
                                        <span class="navi-text"> Invoices </span>
                                    </a>
                                </div>
                                <!-- NOTE - Cancel subscription -->
                                <div class="navi-item mb-2">
                                    <a
                                        @click="setPanel('cancel')"
                                        class="navi-link py-4"
                                        :class="currentPanel == 'cancel' ? 'active' : ''"
                                    >
                                        <span class="navi-icon mr-2">
                                            <span class="svg-icon">
                                                <inline-svg
                                                    src="/media/svg/icons/General/Attachment2.svg"
                                                >
                                                </inline-svg>
                                            </span>
                                        </span>
                                        <span class="navi-text"> Cancel subscription </span>
                                    </a>
                                </div>
                                <!-- NOTE - Delete account -->
                                <div class="navi-item mb-2">
                                    <a
                                        @click="setPanel('deleteaccount')"
                                        class="navi-link py-4"
                                        :class="currentPanel == 'deleteaccount' ? 'active' : ''"
                                    >
                                        <span class="navi-icon mr-2">
                                            <span class="svg-icon">
                                                <inline-svg src="/media/svg/icons/Home/Trash.svg">
                                                </inline-svg>
                                            </span>
                                        </span>
                                        <span class="navi-text"> Delete your Account </span>
                                    </a>
                                </div>
                            </div>
                            <!--end::Nav-->
                        </div>
                        <!--end::Body-->
                    </div>
                    <!--end::Profile Card-->
                </div>
                <!--end::Aside-->

                <transition-group name="fade-in-up" tag="div" class="col-xl-9">
                    <!-- NOTE - Personal Information -->
                    <div v-if="currentPanel == 'personal'" key="1">
                        <!--begin::Card-->
                        <div class="card card-custom">
                            <!--begin::Header-->
                            <div class="card-header py-3">
                                <div class="card-title align-items-start flex-column">
                                    <h3 class="card-label font-weight-bolder text-dark">
                                        Personal Information
                                    </h3>
                                    <span class="text-muted font-weight-bold font-size-sm mt-1"
                                        >View your Personal Information</span
                                    >
                                </div>
                            </div>
                            <!--end::Header-->

                            <div class="card-body">
                                <!-- Profile card -->
                                <div class="card card-custom card-body gutter-b">
                                    <h4>User Profile</h4>
                                    <div class="d-flex align-items-center">
                                        <div class="symbol symbol-100 mr-5 symbol-light-success">
                                            <span
                                                v-if="true"
                                                class="symbol-label font-size-h1 font-weight-bold"
                                            >
                                                {{ currentUser.username.charAt(0).toUpperCase() }}
                                            </span>
                                            <!-- <img class="symbol-label" :src="picture" alt="" /> -->
                                            <i class="symbol-badge bg-success"></i>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <a
                                                class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
                                            >
                                                {{ currentUser.username }}
                                            </a>
                                            <div class="text-muted mt-1">
                                                <div v-if="isPremium" class="text-success">
                                                    <template v-if="isEnterprise">
                                                        Enterprise User
                                                    </template>
                                                    <template v-else> Premium User </template>
                                                </div>
                                                <div v-else class="text-warning">Basic User</div>
                                            </div>
                                            <div class="navi mt-2">
                                                <a class="navi-item">
                                                    <span class="navi-link p-0 pb-2">
                                                        <span class="navi-icon mr-1">
                                                            <span
                                                                class="svg-icon svg-icon-lg svg-icon-primary"
                                                            >
                                                                <!--begin::Svg Icon-->
                                                                <inline-svg
                                                                    src="media/svg/icons/Communication/Mail-notification.svg"
                                                                />
                                                                <!--end::Svg Icon-->
                                                            </span>
                                                        </span>
                                                        <span
                                                            class="navi-text text-muted text-hover-primary"
                                                        >
                                                            {{ currentUser.email }}
                                                        </span>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Enterprise Info -->
                                <template v-if="isEnterprise">
                                    <div class="card card-custom card-body gutter-b">
                                        <h4>Enterprise Logo</h4>
                                        <div class="d-flex align-items-center mt-5">
                                            <div class="symbol symbol-100 mr-5">
                                                <div
                                                    class="symbol-label"
                                                    style="width: 150px; height: 150px"
                                                >
                                                    <EnterpriseLogoDisplay
                                                        overrideDisplay
                                                    ></EnterpriseLogoDisplay>
                                                </div>
                                            </div>

                                            <div class="d-flex flex-column">
                                                <router-link
                                                    to="/support"
                                                    class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                                    >Message us to change your logo</router-link
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <!-- Subscription Card -->
                                <div class="card card-custom card-body gutter-b">
                                    <h4>Subscription Status</h4>
                                    <div v-if="isPremium">
                                        <div
                                            class="d-flex align-items-center bg-light-success rounded p-5"
                                        >
                                            <!--begin::Icon-->
                                            <span class="svg-icon svg-icon-success mr-5">
                                                <span class="svg-icon svg-icon-lg">
                                                    <inline-svg
                                                        src="media/svg/icons/Home/Library.svg"
                                                    ></inline-svg>
                                                </span>
                                            </span>
                                            <!--end::Icon-->

                                            <!--begin::Title-->
                                            <div class="d-flex flex-column flex-grow-1 mr-2">
                                                <router-link
                                                    to="/subscribe"
                                                    class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                                    >Your Hashtastic Susbcription is
                                                    active!</router-link
                                                >
                                                <router-link
                                                    to="/subscribe"
                                                    class="text-dark-50 font-weight-bold"
                                                >
                                                    Your account will be Premium until
                                                    <span class="font-weight-bolder text-success">{{
                                                        currentUser.premiumExpiry
                                                    }}</span>
                                                    and you have access to
                                                    <span class="font-weight-bolder text-success">{{
                                                        currentUser.campaigns
                                                    }}</span>
                                                    Hashtag Performance Campaigns
                                                </router-link>
                                            </div>
                                            <!--end::Title-->
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div
                                            class="d-flex align-items-center bg-light-warning rounded p-5"
                                        >
                                            <!--begin::Icon-->
                                            <span class="svg-icon svg-icon-warning mr-5">
                                                <span class="svg-icon svg-icon-lg">
                                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Home/Library.svg-->
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        width="24px"
                                                        height="24px"
                                                        viewBox="0 0 24 24"
                                                        version="1.1"
                                                    >
                                                        <g
                                                            stroke="none"
                                                            stroke-width="1"
                                                            fill="none"
                                                            fill-rule="evenodd"
                                                        >
                                                            <rect
                                                                x="0"
                                                                y="0"
                                                                width="24"
                                                                height="24"
                                                            ></rect>
                                                            <path
                                                                d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z"
                                                                fill="#000000"
                                                            ></path>
                                                            <rect
                                                                fill="#000000"
                                                                opacity="0.3"
                                                                transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519) "
                                                                x="16.3255682"
                                                                y="2.94551858"
                                                                width="3"
                                                                height="18"
                                                                rx="1"
                                                            ></rect>
                                                        </g></svg
                                                    ><!--end::Svg Icon-->
                                                </span>
                                            </span>
                                            <!--end::Icon-->

                                            <!--begin::Title-->
                                            <div class="d-flex flex-column flex-grow-1 mr-2">
                                                <router-link
                                                    to="/subscribe"
                                                    class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                                    >Your subscription has expired!</router-link
                                                >
                                                <router-link
                                                    to="/subscribe"
                                                    class="text-muted font-weight-bold"
                                                    >Make sure to top up your account in order to
                                                    enjoy all of Hashtastic's features.</router-link
                                                >
                                            </div>
                                            <!--end::Title-->
                                        </div>
                                    </div>
                                </div>

                                <!-- Statistics Card -->
                            </div>

                            <!-- Preloader -->
                            <PagePreloader v-if="formIsLoading" class="gutter-t"></PagePreloader>

                            <!-- Error management -->
                            <CustomAlerts :errors="errors" class="gutter-t col"></CustomAlerts>
                        </div>
                    </div>
                    <!--end:: Personal Information -->

                    <!-- NOTE - PASSWORD CHANGE -->
                    <div v-if="currentPanel == 'password'" key="2">
                        <!--begin::Card-->
                        <div class="card card-custom">
                            <!--begin::Header-->
                            <div class="card-header py-3">
                                <div class="card-title align-items-start flex-column">
                                    <h3 class="card-label font-weight-bolder text-dark">
                                        Change Password
                                    </h3>
                                    <span class="text-muted font-weight-bold font-size-sm mt-1"
                                        >Change the password for your account</span
                                    >
                                </div>
                                <div class="card-toolbar">
                                    <button
                                        type="reset"
                                        class="btn btn-success mr-2"
                                        @click="changePassword"
                                        :disabled="formIsLoading"
                                    >
                                        Save Changes
                                    </button>
                                    <button
                                        type="reset"
                                        class="btn btn-secondary"
                                        @click="cancelPassword"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            <!--end::Header-->

                            <!-- Preloader -->
                            <PagePreloader v-if="formIsLoading" class="gutter-t"></PagePreloader>

                            <!-- Error management -->
                            <CustomAlerts :errors="errors" class="gutter-t col"></CustomAlerts>

                            <!--begin::Form-->
                            <form class="form" method="POST" v-on:submit.prevent="changePassword">
                                <div class="card-body">
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-lg-3 col-form-label text-alert"
                                            >Current Password</label
                                        >
                                        <div class="col-lg-9 col-xl-6">
                                            <input
                                                type="password"
                                                class="form-control form-control-lg form-control-solid mb-2"
                                                placeholder="Current password"
                                                v-model="passwordform.oldp"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-lg-3 col-form-label text-alert"
                                            >New Password</label
                                        >
                                        <div class="col-lg-9 col-xl-6">
                                            <input
                                                type="password"
                                                class="form-control form-control-lg form-control-solid"
                                                value=""
                                                placeholder="New password"
                                                v-model="passwordform.newp"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-lg-3 col-form-label text-alert"
                                            >Verify Password</label
                                        >
                                        <div class="col-lg-9 col-xl-6">
                                            <input
                                                type="password"
                                                class="form-control form-control-lg form-control-solid"
                                                value=""
                                                placeholder="Verify password"
                                                v-model="passwordform.confirmp"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <input type="submit" class="d-none" :disabled="formIsLoading" />
                            </form>
                            <!--end::Form-->
                        </div>
                    </div>
                    <!--end::Password Change-->

                    <!-- NOTE - Email-->
                    <div v-if="currentPanel == 'email'" key="3">
                        <!--begin::Card-->
                        <div class="card card-custom">
                            <!--begin::Header-->
                            <div class="card-header py-3">
                                <div class="card-title align-items-start flex-column">
                                    <h3 class="card-label font-weight-bolder text-dark">
                                        Email Settings
                                    </h3>
                                    <span class="text-muted font-weight-bold font-size-sm mt-1"
                                        >View your Email Settings</span
                                    >
                                </div>
                                <div class="card-toolbar">
                                    <button
                                        type="reset"
                                        class="btn btn-success mr-2"
                                        @click="changeEmail"
                                        :disabled="formIsLoading"
                                    >
                                        Save Changes
                                    </button>
                                    <button
                                        type="reset"
                                        class="btn btn-secondary"
                                        @click="cancelEmail"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            <!--end::Header-->

                            <!-- Preloader -->
                            <PagePreloader v-if="formIsLoading" class="gutter-t"></PagePreloader>

                            <!-- Error management -->
                            <CustomAlerts :errors="errors" class="gutter-t col"></CustomAlerts>

                            <!--begin::Form-->
                            <form class="form" method="POST" v-on:submit.prevent="changeEmail">
                                <div class="card-body">
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-lg-3 col-form-label text-alert"
                                            >Current email address</label
                                        >
                                        <div class="col-lg-9 col-xl-6">
                                            <p class="mt-3">{{ currentUser.email }}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-lg-3 col-form-label text-alert"
                                            >New email address</label
                                        >
                                        <div class="col-lg-9 col-xl-6">
                                            <input
                                                type="email"
                                                class="form-control form-control-lg form-control-solid mb-2"
                                                placeholder="Enter your email here"
                                                v-model="emailform"
                                            />
                                            <input
                                                type="submit"
                                                class="d-none"
                                                :disabled="formIsLoading"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!--end:: Email -->

                    <!-- NOTE - Address -->
                    <div v-if="currentPanel == 'address'" key="4">
                        <!--begin::Card-->
                        <div class="card card-custom">
                            <!--begin::Header-->
                            <div class="card-header py-3">
                                <div class="card-title align-items-start flex-column">
                                    <h3 class="card-label font-weight-bolder text-dark">
                                        Billing Address
                                    </h3>
                                    <span class="text-muted font-weight-bold font-size-sm mt-1"
                                        >Update your billing address</span
                                    >
                                </div>
                                <div class="card-toolbar">
                                    <button
                                        type="reset"
                                        class="btn btn-success mr-2"
                                        @click="changeAddress"
                                        :disabled="formIsLoading"
                                    >
                                        Save Changes
                                    </button>
                                    <button
                                        type="reset"
                                        class="btn btn-secondary"
                                        @click="cancelAddress"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            <!--end::Header-->

                            <!-- Preloader -->
                            <PagePreloader v-if="formIsLoading" class="gutter-t"></PagePreloader>

                            <!-- Error management -->
                            <CustomAlerts :errors="errors" class="gutter-t col"></CustomAlerts>

                            <!--begin::Form-->
                            <form class="form" method="POST" v-on:submit.prevent="changeAddress">
                                <div class="card-body">
                                    <!-- -->
                                    <b-form-group label-cols="3" label="(Optional) Company name">
                                        <b-form-input
                                            placeholder="Enter your company name here"
                                            v-model="addressform.company"
                                        ></b-form-input>
                                    </b-form-group>
                                    <!-- -->
                                    <!-- <b-form-group label-cols="3" label="(Optional) VAT Number">
                                        <b-form-input
                                            placeholder="Enter your company VAT Number here"
                                            v-model="addressform.vatnumber"
                                        ></b-form-input>
                                    </b-form-group> -->
                                    <!-- -->
                                    <b-form-group label-cols="3" label="Full name">
                                        <b-form-input
                                            placeholder="Enter your full name here"
                                            v-model="addressform.fullname"
                                        ></b-form-input>
                                    </b-form-group>
                                    <!-- -->
                                    <b-form-group label-cols="3" label="Street and number">
                                        <b-form-input
                                            placeholder="Enter your street here"
                                            v-model="addressform.street"
                                        ></b-form-input>
                                    </b-form-group>
                                    <!-- -->
                                    <b-form-group
                                        label-cols="3"
                                        label="Street and number complement"
                                    >
                                        <b-form-input
                                            placeholder="(Optional) Enter the rest of your street here"
                                            v-model="addressform.street2"
                                        ></b-form-input>
                                    </b-form-group>
                                    <!-- -->
                                    <b-form-group label-cols="3" label="City">
                                        <b-form-input
                                            placeholder="Enter your city here"
                                            v-model="addressform.city"
                                        ></b-form-input>
                                    </b-form-group>
                                    <!-- -->
                                    <b-form-group label-cols="3" label="Postcode">
                                        <b-form-input
                                            placeholder="Enter your postcode here"
                                            v-model="addressform.postcode"
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group label-cols="3" label="Country">
                                        <b-form-select
                                            v-model="addressform.country"
                                            :options="countries"
                                            autocomplete="off"
                                        ></b-form-select>
                                    </b-form-group>
                                    <!-- -->
                                    <!-- <b-form-group label-cols="3" label="Country">
                                    <b-form-input
                                        placeholder="Enter your country here"
                                        v-model="addressform.country"
                                    ></b-form-input>
                                </b-form-group> -->
                                    <input type="submit" class="d-none" :disabled="formIsLoading" />
                                </div>
                            </form>
                        </div>
                    </div>
                    <!--end:: Address -->

                    <!--  NOTE - Invoices -->
                    <div v-if="currentPanel == 'invoices'" key="5">
                        <!--begin::Card-->
                        <div class="card card-custom">
                            <!--begin::Header-->
                            <div class="card-header py-3">
                                <div class="card-title align-items-start flex-column">
                                    <h3 class="card-label font-weight-bolder text-dark">
                                        Your Invoices
                                    </h3>
                                    <span class="text-muted font-weight-bold font-size-sm mt-1"
                                        >View your Hashtastic Invocies</span
                                    >
                                </div>
                            </div>
                            <!--end::Header-->

                            <div class="card-body">
                                <!-- Preloader -->
                                <PagePreloader
                                    v-if="formIsLoading"
                                    class="gutter-t"
                                ></PagePreloader>
                                <!-- Error management -->
                                <CustomAlerts :errors="errors"></CustomAlerts>
                                <!-- Start payments -->
                                <div v-if="payments.length > 0">
                                    <div class="card card-custom card-stretch gutter-b">
                                        <!--NOTE - Admin header -->
                                        <template v-if="currentUser.id == 3">
                                            <div class="card-header border-0 py-5">
                                                <b-form @submit="submitAdminInvoiceForm">
                                                    <b-form-input
                                                        v-model="admininvoiceform.id"
                                                        placeholder="Enter user ID"
                                                    ></b-form-input>
                                                    <b-button type="submit" variant="primary"
                                                        >Submit</b-button
                                                    >
                                                </b-form>
                                            </div>
                                        </template>

                                        <!--NOTE - End admin header-->

                                        <!--begin::Body-->
                                        <div class="card-body pt-0 pb-3 gutter-t">
                                            <!--begin::Table-->
                                            <div class="table-responsive">
                                                <table
                                                    class="table table-head-custom table-head-bg table-borderless table-vertical-center"
                                                >
                                                    <thead>
                                                        <tr class="text-uppercase">
                                                            <th
                                                                style="min-width: 250px"
                                                                class="pl-7"
                                                            >
                                                                <span class="text-dark-75"
                                                                    >Product</span
                                                                >
                                                            </th>
                                                            <th style="min-width: 100px">
                                                                Date Purchased
                                                            </th>
                                                            <th style="min-width: 100px">
                                                                Payment Method
                                                            </th>
                                                            <th style="min-width: 100px">
                                                                Duration
                                                            </th>
                                                            <th style="min-width: 150px">
                                                                Campaigns
                                                            </th>
                                                            <th style="min-width: 50px">Value</th>
                                                            <th style="min-width: 50px"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="payment in payments"
                                                            :key="payment.id"
                                                        >
                                                            <td class="pl-0 py-8">
                                                                <div
                                                                    class="d-flex align-items-center"
                                                                >
                                                                    <div
                                                                        class="symbol symbol-50 flex-shrink-0 mr-4"
                                                                    >
                                                                        <div
                                                                            class="symbol-label bg-light-success"
                                                                        >
                                                                            <i
                                                                                class="fas fa-check text-success"
                                                                            ></i>
                                                                        </div>
                                                                    </div>

                                                                    <div>
                                                                        <a
                                                                            class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                                                                            >Hashtastic
                                                                            Subscription</a
                                                                        >
                                                                        <span
                                                                            class="text-muted font-weight-bold d-block"
                                                                            @click="
                                                                                getInvoiceJSON(
                                                                                    payment
                                                                                )
                                                                            "
                                                                            >Invoice #{{
                                                                                payment.id
                                                                            }}</span
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                                                                >
                                                                    {{ payment.date }}
                                                                </span>
                                                                <span
                                                                    class="text-muted font-weight-bold"
                                                                >
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                                                                >
                                                                    {{ payment.origin }}
                                                                </span>
                                                                <span
                                                                    class="text-muted font-weight-bold"
                                                                >
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                                                                >
                                                                    <span
                                                                        class="text-success d-inline"
                                                                        >{{ payment.time }}
                                                                    </span>
                                                                    <div
                                                                        v-if="payment.time > 1"
                                                                        class="d-inline"
                                                                    >
                                                                        months
                                                                    </div>
                                                                    <div v-else class="d-inline">
                                                                        month
                                                                    </div>
                                                                </span>
                                                                <span
                                                                    class="text-muted font-weight-bold"
                                                                >
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                                                                >
                                                                    <span
                                                                        class="text-success d-inline"
                                                                        >{{ payment.campaigns }}
                                                                    </span>
                                                                    <div
                                                                        v-if="payment.campaign > 1"
                                                                        class="d-inline"
                                                                    >
                                                                        Campaigns
                                                                    </div>
                                                                    <div v-else class="d-inline">
                                                                        Campaign
                                                                    </div>
                                                                </span>
                                                                <span
                                                                    class="text-muted font-weight-bold"
                                                                >
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                                                                >
                                                                    <template
                                                                        v-if="
                                                                            payment.currency ==
                                                                            'USD'
                                                                        "
                                                                    >
                                                                        ${{ payment.value }}
                                                                    </template>
                                                                    <template
                                                                        v-if="
                                                                            payment.currency ==
                                                                            'EUR'
                                                                        "
                                                                    >
                                                                        {{ payment.value }}€
                                                                    </template>
                                                                </span>
                                                                <span
                                                                    class="text-muted font-weight-bold"
                                                                >
                                                                </span>
                                                            </td>
                                                            <td class="text-right pr-0">
                                                                <b-button
                                                                    @click="getInvoiceJSON(payment)"
                                                                    class="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                                                                    :disabled="formIsLoading"
                                                                >
                                                                    <i
                                                                        class="fas fa-file-invoice"
                                                                    ></i>
                                                                </b-button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <!--end::Table-->
                                        </div>
                                        <!--end::Body-->
                                    </div>
                                </div>
                                <div v-else>
                                    <p>
                                        There are currently no payments associated with this
                                        account.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end:: Invoices  -->

                    <!--  NOTE - Cancel Subscription -->
                    <div v-if="currentPanel == 'cancel'" key="6">
                        <!--begin::Card-->
                        <div class="card card-custom">
                            <!--begin::Header-->
                            <div class="card-header py-3">
                                <div class="card-title align-items-start flex-column">
                                    <h3 class="card-label font-weight-bolder text-dark">
                                        Cancel your subscription
                                    </h3>
                                    <span class="text-muted font-weight-bold font-size-sm mt-1"
                                        >Cancel your Hashtastic subscription</span
                                    >
                                </div>
                            </div>
                            <!--end::Header-->

                            <div class="card-body">
                                <p>
                                    Your account has Automatic Subscriptions
                                    <span class="font-weight-bolder text-danger">disabled</span>,
                                    you will <span class="font-weight-bolder">not</span> be
                                    automatically debited to renew your account.
                                </p>
                                <p>
                                    If you wish to top up your account, visit the
                                    <router-link to="/subscribe">subscribe</router-link> page.
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--end:: Cancel Subscription -->

                    <!--  NOTE - Delete account -->
                    <div v-if="currentPanel == 'deleteaccount'" key="7">
                        <!--begin::Card-->
                        <div class="card card-custom">
                            <!--begin::Header-->
                            <div class="card-header py-3">
                                <div class="card-title align-items-start flex-column">
                                    <h3 class="card-label font-weight-bolder text-dark">
                                        Delete your Hashtastic Account
                                    </h3>
                                    <span class="text-muted font-weight-bold font-size-sm mt-1"
                                        >This action is irreversible</span
                                    >
                                </div>
                            </div>
                            <!--end::Header-->
                            <div class="card-body">
                                <p>
                                    Use the button below to delete your Hashtastic account. Please
                                    note that this action is irreversible.
                                </p>
                                <p>
                                    Once this action is complete you will no longer be able to login
                                    and we will remove all of your user data from our service within
                                    24 hours.
                                </p>
                                <b-button variant="danger" @click="openDeleteModal"
                                    >Permanently delete your account</b-button
                                >
                            </div>
                            <b-modal
                                size="lg"
                                ref="delete-account-modal"
                                centered
                                title="Delete your Hashtastic account"
                            >
                                <!-- Error management -->
                                <CustomAlerts :errors="errors"></CustomAlerts>

                                <p>
                                    Please enter your password in order to authorise the deletion of
                                    your account.
                                </p>

                                <!-- Form -->
                                <form
                                    class="form"
                                    method="POST"
                                    v-on:submit.prevent="deleteAccount"
                                >
                                    <div class="card-body">
                                        <div class="form-group row">
                                            <label
                                                class="col-xl-3 col-lg-3 col-form-label text-alert"
                                                >Enter your password</label
                                            >
                                            <div class="col-lg-9 col-xl-6">
                                                <input
                                                    type="password"
                                                    class="form-control form-control-lg form-control-solid mb-2"
                                                    placeholder="Current password"
                                                    v-model="deleteaccountform.password"
                                                />
                                            </div>
                                        </div>
                                        <input
                                            type="submit"
                                            class="d-none"
                                            :disabled="formIsLoading"
                                        />
                                    </div>
                                </form>

                                <template v-slot:modal-footer="{ ok, cancel, hide }">
                                    <b-button
                                        variant="danger"
                                        @click="deleteAccount()"
                                        :disabled="formIsLoading"
                                    >
                                        Delete your account
                                    </b-button>
                                    <!-- Button with custom close trigger value -->
                                    <b-button variant="outline-secondary" @click="hide()">
                                        Cancel
                                    </b-button>
                                </template>
                            </b-modal>
                            <!-- END Modal -->
                        </div>
                    </div>
                    <!--end:: Delete account -->
                </transition-group>
            </div>
            <!-- End::row -->
        </template>
        <!-- SECTION - Invoice -->
        <template v-if="currentPage == 'invoice'">
            <div class="card card-custom overflow-hidden">
                <div class="card-body p-0">
                    <!-- begin: Invoice-->
                    <!-- begin: Invoice header-->
                    <div class="row justify-content-center py-8 px-8 py-md-27 px-md-0">
                        <div class="col-md-9">
                            <div
                                class="d-flex justify-content-between pb-10 pb-md-20 flex-column flex-md-row"
                            >
                                <h1 class="display-4 font-weight-boldest mb-10">
                                    INVOICE <sub class="text-success">(PAID)</sub>
                                </h1>
                                <div class="d-flex flex-column align-items-md-end px-0">
                                    <!--begin::Logo-->
                                    <a href="#" class="mb-5">
                                        <img
                                            src="/media/logos/hashtastic-logo-color.png"
                                            alt=""
                                            class="max-h-30px"
                                        />
                                    </a>
                                    <!--end::Logo-->
                                    <span class="d-flex flex-column align-items-md-end opacity-70">
                                        <span>{{ invoice.hashtastic_company_name }}</span>
                                        <span
                                            >21 rue Camille Saint Saens, 94440 Santeny, France</span
                                        >
                                        <span>VAT Number: {{ invoice.hashtastic_tva_num }}</span>
                                        <span>SIRET: {{ invoice.hashtastic_siret }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="border-bottom w-100"></div>
                            <div class="d-flex justify-content-between pt-6">
                                <div class="d-flex flex-column flex-root">
                                    <span class="font-weight-bolder mb-2">PAYMENT DATE</span>
                                    <span class="opacity-70">{{ invoice.date_paid }}</span>
                                    <span class="opacity-70">Via {{ invoice.payment_method }}</span>
                                </div>
                                <div class="d-flex flex-column flex-root">
                                    <span class="font-weight-bolder mb-2">INVOICE NO.</span>
                                    <span class="opacity-70"
                                        ># HS000{{ invoice.invoice_number }} <br />REF:
                                        {{ invoice.invoice_reference }}</span
                                    >
                                </div>
                                <div class="d-flex flex-column flex-root">
                                    <span class="font-weight-bolder mb-2">INVOICE TO.</span>
                                    <span class="opacity-70">
                                        {{ invoice.client_email }}<br />
                                        {{ invoice.client_name }}<br />
                                        <template v-if="invoice.invoice_address_company">
                                            <strong>{{ invoice.invoice_address_company }}</strong
                                            ><br />
                                        </template>
                                        <!-- NOTE - VAT Number -->
                                        <!-- <template v-if="invoice.invoice_address_vatnumber">
                                            VAT: {{ invoice.invoice_address_vatnumber }}<br />
                                        </template> -->
                                        <template v-if="invoice.invoice_address_fullname">
                                            {{ invoice.invoice_address_fullname }}<br />
                                        </template>
                                        <template v-if="invoice.invoice_address_street">
                                            {{ invoice.invoice_address_street }}<br />
                                        </template>
                                        <template v-if="invoice.invoice_address_street2">
                                            {{ invoice.invoice_address_street2 }}<br />
                                        </template>
                                        <template v-if="invoice.invoice_address_postcode">
                                            {{ invoice.invoice_address_postcode }}<br />
                                        </template>
                                        <template v-if="invoice.invoice_address_city">
                                            {{ invoice.invoice_address_city }}<br />
                                        </template>
                                        <template v-if="invoice.invoice_address_country">
                                            {{ invoice.invoice_address_country }}<br />
                                        </template>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end: Invoice header-->
                    <!-- begin: Invoice body-->
                    <div class="row justify-content-center py-8 px-8 py-md-10 px-md-0">
                        <div class="col-md-9">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th
                                                class="pl-0 font-weight-bold text-muted text-uppercase"
                                            >
                                                Description
                                            </th>
                                            <th
                                                class="text-right font-weight-bold text-muted text-uppercase"
                                            >
                                                Duration
                                            </th>
                                            <th
                                                class="text-right font-weight-bold text-muted text-uppercase"
                                            >
                                                Campaigns
                                            </th>
                                            <th
                                                class="text-right pr-0 font-weight-bold text-muted text-uppercase"
                                            >
                                                Amount
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="font-weight-boldest">
                                            <td class="pl-0 pt-7">Hashtastic Subscription</td>
                                            <td class="text-right pt-7">
                                                {{ invoice.invoice_duration }}
                                                Month<template v-if="invoice.invoice_duration > 1"
                                                    >s</template
                                                >
                                            </td>
                                            <td class="text-right pt-7">
                                                {{ invoice.invoice_campaigns }}
                                            </td>
                                            <td class="text-primary pr-0 pt-7 text-right">
                                                <template v-if="invoice.invoice_currency == 'USD'">
                                                    $ {{ invoice.invoice_ht }}
                                                </template>
                                                <template v-if="invoice.invoice_currency == 'EUR'">
                                                    {{ invoice.invoice_ht }} €
                                                </template>
                                            </td>
                                        </tr>
                                        <template v-if="invoice.invoice_hastax">
                                            <tr class="font-weight-boldest border-bottom-0">
                                                <td class="border-top-0 pl-0 py-4"></td>
                                                <td class="border-top-0 text-right py-4"></td>
                                                <td class="border-top-0 text-right py-4">
                                                    Sub-total
                                                </td>
                                                <td
                                                    class="text-primary border-top-0 pr-0 py-4 text-right"
                                                >
                                                    <template
                                                        v-if="invoice.invoice_currency == 'USD'"
                                                    >
                                                        $ {{ invoice.invoice_ht }}
                                                    </template>
                                                    <template
                                                        v-if="invoice.invoice_currency == 'EUR'"
                                                    >
                                                        {{ invoice.invoice_ht }} €
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class="font-weight-boldest border-bottom-0">
                                                <td class="border-top-0 pl-0 py-4"></td>
                                                <td class="border-top-0 text-right py-4"></td>
                                                <td class="border-top-0 text-right py-4">
                                                    VAT ({{ invoice.invoice_vatpercentage }}%)
                                                </td>
                                                <td
                                                    class="text-primary border-top-0 pr-0 py-4 text-right"
                                                >
                                                    <template
                                                        v-if="invoice.invoice_currency == 'USD'"
                                                    >
                                                        $ {{ invoice.invoice_tax }}
                                                    </template>
                                                    <template
                                                        v-if="invoice.invoice_currency == 'EUR'"
                                                    >
                                                        {{ invoice.invoice_tax }} €
                                                    </template>
                                                </td>
                                            </tr>
                                        </template>
                                        <!-- <tr class="font-weight-boldest border-bottom-0">
                                            <td class="border-top-0 pl-0 py-4">
                                                Front-End Development
                                            </td>
                                            <td class="border-top-0 text-right py-4">120</td>
                                            <td class="border-top-0 text-right py-4">$40.00</td>
                                            <td
                                                class="text-danger border-top-0 pr-0 py-4 text-right"
                                            >
                                                $4800.00
                                            </td>
                                        </tr> -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- end: Invoice body-->
                    <!-- begin: Invoice footer-->
                    <div class="row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0">
                        <div class="col-md-9">
                            <div class="table-responsive">
                                <table class="table text-right">
                                    <thead>
                                        <tr>
                                            <th class="font-weight-bold text-muted text-uppercase">
                                                TOTAL AMOUNT
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="font-weight-bolder">
                                            <td
                                                class="text-success font-size-h3 font-weight-boldest"
                                            >
                                                <template v-if="invoice.invoice_currency == 'USD'">
                                                    $ {{ invoice.invoice_total }}
                                                </template>
                                                <template v-if="invoice.invoice_currency == 'EUR'">
                                                    {{ invoice.invoice_total }} €
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- end: Invoice footer-->
                    <!-- begin: Invoice action-->
                    <div class="row justify-content-center py-8 px-8 py-md-10 px-md-0">
                        <div class="col-md-9">
                            <div class="d-flex justify-content-between">
                                <button
                                    type="button"
                                    class="btn btn-light-primary font-weight-bold d-print-none"
                                    onclick="window.print();"
                                >
                                    <i class="fas fa-download ml-2"></i> Download Invoice
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-light-success font-weight-bold d-print-none"
                                    @click="returnToProfile"
                                >
                                    <i class="fas fa-undo ml-1"></i> Return to Profile
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- end: Invoice action-->
                    <!-- end: Invoice-->
                </div>
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
.navi-link {
    cursor: pointer;
}
</style>
<style scoped>
.list-enter-active,
.list-leave-active,
.list-move {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
}

.list-enter {
    opacity: 0;
    transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
    opacity: 1;
    transform: translateX(0) scaleY(1);
}

.list-leave-active {
    position: absolute;
}

.list-leave-to {
    opacity: 0;
    transform: scaleY(0);
    transform-origin: center top;
}
</style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import EnterpriseLogoDisplay from "@/view/content/Custom/EnterpriseLogoDisplay.vue";

// Getters
import { SET_USER } from "@/core/services/store/auth.module";
import { LOGOUT } from "@/core/services/store/auth.module";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "UserProfilePage",
    mixins: [axiosErrorManagement],
    components: {
        PagePreloader,
        CustomAlerts,
        EnterpriseLogoDisplay,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,
            formIsLoading: false,
            invoiceIsLoading: false,

            // Displayers
            currentPanel: "personal",
            currentPage: "profile",

            // Stored data
            payments: [],

            // Invoice displayers
            invoice: {},

            // Error management
            errors: [],

            // Forms
            passwordform: {
                oldp: "",
                newp: "",
                confirmp: "",
            },
            emailform: "",
            addressform: {
                company: "",
                vatnumber: "",
                fullname: "",
                street: "",
                street2: "",
                city: "",
                postcode: "",
                country: "",
            },
            deleteaccountform: {
                password: "",
            },
            admininvoiceform: {
                id: "",
            },
            countries: [],
        };
    },

    methods: {
        getPayments() {
            axios.get("profile/payments").then((response) => {
                this.payments = response.data.data;
            });
        },

        getCountries() {
            axios.get("profile/countrylist").then((response) => {
                this.countries = response.data;
            });
        },

        /**
         * SECTION - Legacy code for getting PDFs the old way
         */
        // getInvoice(payment) {
        //     // Reset errors
        //     this.errors = [];

        //     // Set preloader
        //     this.formIsLoading = true;

        //     // Perform post
        //     axios({
        //         method: "post",
        //         responseType: "blob",
        //         data: {
        //             invoice: payment.id,
        //         },
        //         url: "profile/invoice",
        //     })
        //         // .post("profile/invoice", {
        //         //     responseType: "blob",
        //         //     invoice: payment.id,
        //         // })
        //         .then((response) => {
        //             var url = window.URL.createObjectURL(new Blob([response.data]));
        //             var link = document.createElement("a");
        //             link.href = url;
        //             link.setAttribute("download", "Hashtastic Invoice #" + payment.id + ".pdf");
        //             document.body.appendChild(link);
        //             link.click();
        //             // FIXME - Does this work?
        //             if (url) (url = URL.revokeObjectURL(url)), undefined;

        //             // Error management
        //             // if (data.messages.length > 0) {
        //             //     data.messages.forEach((item) => {
        //             //         this.errors.push({ type: item.type, message: item.message });
        //             //     });
        //             // }
        //         })
        //         .catch((error) => {
        //             this.errors.push(this.handleAxiosErrors(error));
        //         })
        //         .finally(() => {
        //             // Set preloader
        //             this.formIsLoading = false;
        //         });
        // },
        submitAdminInvoiceForm() {
            event.preventDefault();

            // Reset errors
            this.errors = [];

            // Set preloader
            this.formIsLoading = true;

            axios
                .post("admin/getinvoicesforuser", {
                    userid: this.admininvoiceform.id,
                })
                .then((response) => {
                    this.payments = response.data.data;
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Set preloader
                    this.formIsLoading = false;
                });
        },

        /**
         * SECTION - Get JSON to populate new invoice style
         */
        getInvoiceJSON(payment) {
            // Reset errors
            this.errors = [];

            // Empty our invoice variable
            this.invoice = {};

            // Set preloader
            this.formIsLoading = true;

            axios
                .post("profile/invoicejson", {
                    invoice: payment.id,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Set the invoice to the new data
                        this.invoice = data.data;

                        // Change page
                        this.currentPage = "invoice";
                    }

                    // Error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({ type: item.type, message: item.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Set preloader
                    this.formIsLoading = false;
                });
        },

        returnToProfile() {
            this.currentPage = "profile";
        },

        // setPanel
        setPanel(panel) {
            // Reset errors if we're switching panels
            if (this.currentPanel != panel) {
                this.errors = [];
            }
            // Reset loader
            this.formIsLoading = false;
            // Set panel
            this.currentPanel = panel;
        },

        // Change password
        changePassword() {
            // Reset errors
            this.errors = [];

            // Set preloader
            this.formIsLoading = true;

            // Get data
            var form = this.passwordform;
            var newp = form.newp;
            var oldp = form.oldp;
            var confirmp = form.confirmp;

            // Perform post
            axios
                .post("profile/passwordchange", {
                    new: newp,
                    old: oldp,
                    confirm: confirmp,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Get success
                    if (data.status == "OK") {
                        // Empty fields
                        this.passwordform.oldp = "";
                        this.passwordform.newp = "";
                        this.passwordform.confirmp = "";
                    }

                    // Error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({ type: item.type, message: item.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Reset loader
                    this.formIsLoading = false;
                });
        },

        changeAddress() {
            // Reset errors
            this.errors = [];

            // Set preloader
            this.formIsLoading = true;

            // Perform post
            axios
                .post("profile/addresschange", {
                    company: this.addressform.company,
                    vatnumber: this.addressform.vatnumber,
                    fullname: this.addressform.fullname,
                    street: this.addressform.street,
                    street2: this.addressform.street2,
                    city: this.addressform.city,
                    postcode: this.addressform.postcode,
                    country: this.addressform.country,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Get user data
                        var user = data.data;

                        // Update currentUser
                        this.$store.commit("auth/SET_USER", user);
                    }

                    // Error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({ type: item.type, message: item.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Reset loader
                    this.formIsLoading = false;
                });
        },

        // Change email
        changeEmail() {
            // Reset errors
            this.errors = [];

            // Set preloader
            this.formIsLoading = true;

            // Get data
            var email = this.emailform;

            // Perform post
            axios
                .post("profile/emailchange", {
                    email: email,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Get success
                    if (data.status == "OK") {
                        // Empty fields
                        this.emailform = "";

                        // Get user data
                        var user = data.data;

                        // Update currentUser
                        this.$store.commit("auth/SET_USER", user);
                    }

                    // Error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({ type: item.type, message: item.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Reset loader
                    this.formIsLoading = false;
                });
        },

        openDeleteModal() {
            // Reset errors
            this.errors = [];
            // Open modal
            this.$refs["delete-account-modal"].show();
        },
        ...mapActions({
            signOutAction: "auth/signOut",
        }),
        async signOut() {
            await this.signOutAction();
            this.$router.push({ name: "login" }).catch(() => {});
        },
        deleteAccount() {
            // Reset errors
            this.errors = [];

            // Set preloader
            this.formIsLoading = true;

            axios
                .post("profile/deleteaccount", {
                    password: this.deleteaccountform.password,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Get success
                    if (data.status == "OK") {
                        this.signOut();
                    }

                    // Error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({ type: item.type, message: item.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Reset loader
                    this.formIsLoading = false;
                });
        },

        cancelAddress() {
            this.cancelDefaults();
        },

        cancelEmail() {
            this.cancelDefaults();
            this.emailform = "";
        },

        cancelPassword() {
            this.cancelDefaults();
            this.passwordform.oldp = "";
            this.passwordform.newp = "";
            this.passwordform.confirmp = "";
        },

        cancelDefaults() {
            // Reset errors
            this.errors = [];
        },

        setDefaultAddress() {
            this.addressform.company = this.currentUser.address_company;
            this.addressform.vatnumber = this.currentUser.address_vatnumber;
            this.addressform.fullname = this.currentUser.address_fullname;
            this.addressform.street = this.currentUser.address_street;
            this.addressform.street2 = this.currentUser.address_street2;
            this.addressform.city = this.currentUser.address_city;
            this.addressform.postcode = this.currentUser.address_postcode;
            this.addressform.country = this.currentUser.address_country;
        },
    },

    mounted() {
        // Get user data
        this.getPayments();

        // Get country list
        this.getCountries();

        // Set default address
        this.setDefaultAddress();

        // Set page preloader
        this.pageIsLoaded = true;
        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "User Profile", route: "profile" }]);
    },

    computed: {
        ...mapGetters({
            currentUser: "auth/currentUser",
            isPremium: "auth/isPremium",
            isEnterprise: "auth/isEnterprise",
        }),
    },
};
</script>
